import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SaveErrorService {
  private _state: SaveErrorStates = SaveErrorStates.noError;

  get state(): SaveErrorStates {
    return this._state;
  }
  set state(value: SaveErrorStates) {
    // Once the failed state is reached there is no going back
    if (this._state == SaveErrorStates.failed) return;

    this._state = value;
  }

  constructor() {}
}

export enum SaveErrorStates {
  noError,
  slow,
  failed,
}
